import gameIds from 'a/hub/data/GameIds';

export const CONTENT_VERSION = '0.4';

export const GAME_ID = gameIds.INKBLOTT;

export const STAGE_WIDTH = 1024;
export const STAGE_HEIGHT = 576;
export const STAGE_CENTER = STAGE_WIDTH / 2;

export const HUD_HEIGHT = 110; // Height of the hud element

// These two numbers together fit the stage width of 1024 pretty nicely
// for an exclusively vertically scrolling game
export const TILE_SIZE = 93; // Size of an individual tile
export const RECT_HEIGHT = 2 * TILE_SIZE; // Max height of a tile layer rect
export const RECT_WIDTH = 5 * TILE_SIZE; // Max width of a tile layer rect
export const ROW_WIDTH = 11; // Number of tiles in a row
export const NUM_CRYSTALS = 3; // Hard coded number of crystals
export const NUM_MORPHEME_CONTAINERS = 3; // Hard coded number of morpheme containers
export const TILE_NUMERALS = '0123456789'; // Sequence of numbers for level design indexing
export const TILE_CAPITALS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'; // Sequence of capital letters for level design indexing
export const TILE_LOWER = 'abcdefghijklmnopqrstuvwxyz'; // Sequence of lowercase letters for level design indexing

// Size numbers for SVG width and height of the SentenceUI
export const SENTENCE_BACKING_WIDTH = 924;
export const SENTENCE_BACKING_HEIGHT = 310;
export const DEFINITION_WIDTH = 650;
export const DEFINITION_HEIGHT = 108;

export const DEBUG_DIG_THROUGH_ROCK = false; // Debug flag to allow digging through rock

// Levels that use alternative definition of "er", to avoid rewriting curriculum parser
export const ER_ALT_DEF_QUESTIONS = [27, 28, 29, 31, 39, 40, 42, 44, 75, 77, 78, 81, 84, 99, 101, 102];

export const ALT_ER_DEFINITION_STRING = 'er2';

export const THREE_PART_WORD_LEVELS = [28, 29, 30, 33, 34, 35, 36, 37];

// Same as above, but for Lectura levels.

export const ERO_ALT_DEF_QUESTIONS = [111, 112, 115, 116, 117, 119, 121, 127];

export const ALT_ERO_DEFINITION_STRING = 'ero2';

export const ERA_ALT_DEF_QUESTIONS = [113, 126];

export const ALT_ERA_DEFINITION_STRING = 'era2';

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD_VIEW: 'STANDARD_VIEW',
  LOADING: 'LOADING',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  MODIFY_CRYSTAL_COUNT: 'MODIFY_CRYSTAL_COUNT',
  SET_LEVEL: 'SET_LEVEL',
  STORE_MORPHEME: 'STORE_MORPHEME',
  RETURN_MORPHEME: 'RETURN_MORPHEME',
  APPLY_MORPHEME: 'APPLY_MORPHEME',
  STORE_SENTENCE_MORPHEME: 'STORE_SENTENCE_MORPHEME',
  SET_CRYSTAL_COLLECTED: 'SET_CRYSTAL_COLLECTED',
  SET_SENTENCE_COMPLETE: 'SET_SENTENCE_COMPLETE',
  SET_LEVEL_COMPLETED: 'SET_LEVEL_COMPLETED',
  SET_TILES: 'SET_TILES',
  DIG_TILE: 'DIG_TILE',
  SAVE_SCREEN_COORDINATES: 'SAVE_SCREEN_COORDINATES',
  SET_PLAYER_POS: 'SET_PLAYER_POS',
  SET_LEVEL_DATA: 'SET_LEVEL_DATA',
  QUICK_ROUND: 'QUICK_ROUND',
  SET_HAS_SEEN_ONBOARDING: 'SET_HAS_SEEN_ONBOARDING',
};

// Sentence States
// These define whether we show various sentence/word dig/ending screens
export const GAME_STATE = {
  INPUT_LOCKED: 'input_locked',
  INPUT_ALLOWED: 'input_allowed',
  MOVING: 'moving',
  WORD_DIG: 'word_dig',
  SENTENCE: 'sentence',
  END_GAME: 'end_game',
};

// Sentence result states
// To decide logic after user finishes a sentence cavern
export const RESULT_STATE = {
  SUCCESS: 'success',
  FAILURE: 'failure',
  BACK: 'back',
};

// Morpheme states
// The states for word parts in word mining
export const MORPHEME_STATE = {
  LOCKED: 'locked', // Unable to be taken
  AVAILABLE: 'available', // Able to be mined
  MINED: 'mined', // Mined and stored in morpheme tray
};

// Tile Types
export const TILE_TYPES = {
  DIRT: 0, // Diggable tiles
  ROCK: 1, // Non-diggable tiles
  DUG_OUT: 2, // Dug-out diggable tiles
  WORD: 3, // Tiles containing collectable words
  SENTENCE: 4, // Tiles containing target sentences
  CRYSTAL: 5, // Tiles containing word crystals
  END: 6, // Tiles containing the end area
  END_EXTRA: 7, // Extra ending tiles
  GRASS: 8, // Grass for top layer
  AIR: 9, // Air for the very top
};

// Blott animation state. Combines with dir to pick correct animation
export const BLOTT_STATE = {
  IDLE_TWO: 'idle_two',
  IDLE_ONE: 'idle_one',
  DRILL: 'drill',
  WALK: 'walk',
};

// Blot direction. Combines with animation state to pick correct animation
export const BLOTT_DIR = {
  UP: 'up',
  RIGHT: 'right',
  DOWN: 'down',
  LEFT: 'left',
};
